module.exports = __webpack_public_path__ + "img/user-secret.f0044284.svg";